import Seo from "@/components/Seo";
import { useLang, route } from "../i18n";
import { COMPANY } from "../data/config";
import { ButtonPrimary } from "../components/Buttons";
import { AviahWatermark } from "../components/AviahMark";

const NotFound = () => {
  const { lang, t } = useLang();
  const n = t.notFound;

  return (
    <section className="relative flex min-h-[80vh] items-center overflow-hidden bg-[#F4F0E8]" data-testid="not-found">
      <Seo title={`404 — ${COMPANY.name}`} siteName={COMPANY.name} />
      <AviahWatermark className="absolute -right-24 top-1/2 h-96 w-96 -translate-y-1/2 text-[#171717] opacity-[0.04]" />
      <div className="relative mx-auto max-w-7xl px-5 py-32 sm:px-8">
        <p className="text-7xl font-light tracking-tight text-[#C6A46A] sm:text-8xl">404</p>
        <h1 className="mt-6 max-w-xl text-2xl font-light tracking-tight text-[#171717] sm:text-3xl">{n.title}</h1>
        <p className="mt-4 max-w-md text-sm text-[#171717]/60">{n.copy}</p>
        <div className="mt-10">
          <ButtonPrimary to={route(lang, "home")} testid="not-found-home">
            {n.cta}
          </ButtonPrimary>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
